export class mdlVerifyDetails_UpdateMobileNoReq{
   public RegNo: string;
   public Lng: string;
   public  InsuredIdNo: string;
   public IDExpiry: string;
   public DOB: string;
   public NewMobileNo: string;
   public OTP: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlVerifyDetails_UpdateMobileNoReq.ts